/**
 * Card Carousel Module
 * Initializes Swiper carousel for card carousel modules
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all card carousel modules
  const carousels = document.querySelectorAll('.cc-swiper');
  
  carousels.forEach(function(swiperElement) {
    // Get config from data attribute
    const configString = swiperElement.getAttribute('data-swiper-config');
    const moduleId = swiperElement.getAttribute('data-module-id');
    
    if (!configString || !moduleId) {
      console.warn('Card Carousel: Missing config or module ID');
      return;
    }
    
    try {
      // Parse configuration
      const config = JSON.parse(configString);
      
      // Check if we have content column and determine slide width
      const hasContentColumn = swiperElement.closest('.cc-content')?.classList.contains('has-content-column');
      const isBreakout = swiperElement.closest('.cc-slider-outer')?.classList.contains('cc-slider-outer--breakout');
      
      // Set slidesPerView based on content column and breakout status
      let slidesPerView = config.slidesPerView || 1;
      let spaceBetween = config.spaceBetween || 24;
      
      if (hasContentColumn) {
        if (isBreakout) {
          // Breakout with content column: show 2.5 slides
          slidesPerView = 2.5;
        } else {
          // Normal with content column: show 1.5 slides
          slidesPerView = 1.5;
        }
      }
      
      // Create Swiper instance
      const swiper = new Swiper(swiperElement, {
        // Basic configuration
        slidesPerView: 1.5,
        spaceBetween: spaceBetween,
        
        // Navigation
        navigation: config.navigation ? {
          nextEl: `.cc-next-${moduleId}`,
          prevEl: `.cc-prev-${moduleId}`,
        } : false,
        
        // Pagination
        pagination: config.pagination ? {
          el: `.cc-pagination-${moduleId}`,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        } : false,
        
        // Autoplay
        autoplay: config.autoplay || false,
        
        // Breakpoints (only apply when no content column)
        breakpoints: hasContentColumn ? {} : (config.breakpoints || {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: slidesPerView,
          },
        }),
        
        // Additional options
        speed: 600,
        grabCursor: true,
        watchOverflow: true,
        
        // Events
        on: {
          init: function() {
            // Add initialized class
            swiperElement.classList.add('swiper-initialized');
            
            // Show navigation elements
            const arrows = document.querySelectorAll(`.cc-prev-${moduleId}, .cc-next-${moduleId}`);
            arrows.forEach(arrow => {
              arrow.style.opacity = '1';
              arrow.style.pointerEvents = 'auto';
            });
          },
          
          slideChange: function() {
            // Update active states if needed
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide) {
              // Add any slide-specific animations here
            }
          },
          
          reachEnd: function() {
            // Handle end of carousel
          },
          
          reachBeginning: function() {
            // Handle beginning of carousel
          }
        }
      });
      
      // Store swiper instance for external access
      swiperElement.swiper = swiper;
      
      // Add hover pause for autoplay
      if (config.autoplay) {
        swiperElement.addEventListener('mouseenter', function() {
          swiper.autoplay.stop();
        });
        
        swiperElement.addEventListener('mouseleave', function() {
          swiper.autoplay.start();
        });
      }
      
      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          swiper.update();
        }, 250);
      });
      
      console.log(`Card Carousel initialized: ${moduleId}`);
      
    } catch (error) {
      console.error('Card Carousel: Error initializing Swiper:', error);
    }
  });
  
  // Handle navigation arrow clicks (fallback)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cc-arrow')) {
      const arrow = e.target.closest('.cc-arrow');
      const swiperElement = arrow.closest('.card-carousel-module')?.querySelector('.cc-swiper');
      
      if (swiperElement && swiperElement.swiper) {
        if (arrow.classList.contains('cc-prev')) {
          swiperElement.swiper.slidePrev();
        } else if (arrow.classList.contains('cc-next')) {
          swiperElement.swiper.slideNext();
        }
      }
    }
  });
  
  // Handle pagination dot clicks (fallback)
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('swiper-pagination-bullet')) {
      const dot = e.target;
      const swiperElement = dot.closest('.card-carousel-module')?.querySelector('.cc-swiper');
      
      if (swiperElement && swiperElement.swiper) {
        const index = Array.from(dot.parentElement.children).indexOf(dot);
        swiperElement.swiper.slideTo(index);
      }
    }
  });
});
